var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import AttachmentService from "../../../../Services/Attachment.service";
import SendMessageActionEmailRecipientForm from "../../Message/SendMessageActionEmailRecipientForm";
import EmailForm from "../../Message/EmailForm";
import useService from "../../../Hooks/useService";
import MessageTemplateService from "../../../../Services/MessageTemplate.service";
import PersonService from "../../../../Services/Person.service";
import CheckboxField from "../../../Form/CheckboxField";
import SendMessageAsNoteForm from "../../Message/SendMessageAsNoteForm";
import useHasPermission from "../../../Hooks/useHasPermission";
import NoteTypeService from "../../../../Services/NoteType.service";
import AttachmentsField from "../../../Form/AttachmentsField";
const INSTITUTIONAL_MESSAGE_TEMPLATE_ID = "2866dffb-a946-4219-8839-2a96ead4bc20";
export const CREATE_EMAIL_GET_CRITERIA = (formState, { exportNodeId, pipelineId }) => {
    var _a, _b, _c, _d;
    const PERSON_LOADER_DELEGATE_ID = uuid();
    const personLoaderDelegate = {
        id: PERSON_LOADER_DELEGATE_ID,
        type: "PersonLoader",
        criteria: {
            personId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
        },
    };
    const OPPORTUNITY_LOADER_DELEGATE_ID = uuid();
    const opportunityLoaderDelegate = {
        id: OPPORTUNITY_LOADER_DELEGATE_ID,
        type: "OpportunityLoader",
        criteria: {
            subjectId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
            pipelineId: {
                isReference: false,
                value: pipelineId,
            },
        },
    };
    return {
        delegates: [personLoaderDelegate, opportunityLoaderDelegate],
        criteria: {
            body: { value: formState.body, isReference: false },
            subject: { value: formState.subject, isReference: false },
            // @ts-expect-error - TS2339 - Property 'isReference' does not exist on type 'PersonLite | { isReference: true; }'.
            recipientAffiliationId: formState.recipient.isReference
                ? {
                    isReference: true,
                    workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                    propertyName: "affiliationId",
                }
                : {
                    // @ts-expect-error - TS2339 - Property 'affiliationId' does not exist on type 'PersonLite | { isReference: true; }'.
                    value: formState.recipient.affiliationId,
                    isReference: false,
                },
            // @ts-expect-error - TS2339 - Property 'isReference' does not exist on type 'PersonLite | { isReference: true; }'.
            senderAffiliationId: formState.sender.isReference
                ? {
                    isReference: true,
                    workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
                    propertyName: "assignedPersonAffiliationId",
                }
                : {
                    // @ts-expect-error - TS2339 - Property 'affiliationId' does not exist on type 'PersonLite | { isReference: true; }'.
                    value: formState.sender.affiliationId,
                    isReference: false,
                },
            sendToPersonalEmail: {
                value: formState.sendToPersonal,
                isReference: false,
            },
            sendToInstitutionalEmail: {
                value: formState.sendToInstitutional,
                isReference: false,
            },
            logMessage: { value: formState.logMessage, isReference: false },
            saveMessageAsNote: {
                value: formState.noteFromMessage,
                isReference: false,
            },
            noteTypeIds: {
                value: (_b = (_a = formState.selectedNoteTypes) === null || _a === void 0 ? void 0 : _a.map((noteType) => noteType.id)) !== null && _b !== void 0 ? _b : [],
                isReference: false,
            },
            attachmentIds: {
                value: (_c = formState.attachments) === null || _c === void 0 ? void 0 : _c.map((attachment) => attachment.attachmentId),
                isReference: false,
            },
            campaignId: {
                value: null,
                isReference: false,
            },
            messageTemplateId: {
                value: INSTITUTIONAL_MESSAGE_TEMPLATE_ID,
                isReference: false,
            },
            templateVariables: {
                value: {
                    studentId: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "srcSystemId",
                    },
                    studentFullName: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "fullName",
                    },
                    studentFirstName: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "firstName",
                    },
                    studentLastName: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "lastName",
                    },
                    studentNickname: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "nickname",
                    },
                    studentPersonalEmailAddress: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "personalEmailAddress",
                    },
                    studentInstitutionalEmailAddress: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "institutionalEmailAddress",
                    },
                    studentCumulativeGPA: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "cumulativeGPA",
                    },
                    studentDegreeName: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "degreeName",
                    },
                    studentProgramName: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "programName",
                    },
                    advisorFullName: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "advisorFullName",
                    },
                    coachFullName: {
                        isReference: true,
                        workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                        propertyName: "coachFullName",
                    },
                    assignedToFullName: {
                        isReference: true,
                        propertyName: "assignedToFullName",
                        workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
                    },
                },
                isReference: false,
            },
            pipelineId: {
                propertyName: "pipelineId",
                isReference: true,
                workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
            },
            inlineAttachments: {
                value: (_d = formState.inlineAttachments) !== null && _d !== void 0 ? _d : false,
                isReference: false,
            },
            opportunityId: {
                isReference: true,
                propertyName: "opportunityId",
                workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
            },
        },
    };
};
export const CREATE_EMAIL_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    // We need to load in the sender and the recipient
    const [sender, recipient, selectedNoteTypes, attachments] = yield Promise.all([
        // sender
        criteria.senderAffiliationId.isReference
            ? Promise.resolve({
                isReference: true,
                affiliationId: null,
            })
            : PersonService.peopleFromAffiliationIds([
                criteria.senderAffiliationId.value,
            ]).then((people) => people[0]),
        // recipient -- this could be a reference.  If it is, we just hard code it for now
        criteria.recipientAffiliationId.isReference
            ? Promise.resolve({
                isReference: true,
                affiliationId: null,
            })
            : PersonService.peopleFromAffiliationIds([
                criteria.recipientAffiliationId.value,
            ]).then((people) => people[0]),
        ((_a = criteria.noteTypeIds) === null || _a === void 0 ? void 0 : _a.value)
            ? NoteTypeService.findByIds(criteria.noteTypeIds.value)
            : Promise.resolve([]),
        criteria.attachmentIds.value
            ? AttachmentService.findAllByIds(criteria.attachmentIds.value)
            : Promise.resolve([]),
    ]);
    return {
        subject: criteria.subject.value,
        body: criteria.body.value,
        // @ts-expect-error - TS2322 - Type 'PersonLite | { isReference: boolean; affiliationId: null; }' is not assignable to type 'PersonLite | { isReference: true; }'.
        recipient,
        // @ts-expect-error - TS2322 - Type 'PersonLite | { isReference: boolean; affiliationId: null; }' is not assignable to type 'PersonLite | { isReference: true; }'.
        sender,
        sendToPersonal: criteria.sendToPersonalEmail.value,
        sendToInstitutional: criteria.sendToInstitutionalEmail.value,
        template: null,
        logMessage: (_b = criteria.logMessage) === null || _b === void 0 ? void 0 : _b.value,
        noteFromMessage: criteria.saveMessageAsNote.value,
        selectedNoteTypes,
        attachments,
        templateVariables: criteria.templateVariables,
        inlineAttachments: (_c = criteria.inlineAttachments) === null || _c === void 0 ? void 0 : _c.value,
    };
});
const CreateEmailWorkflowNodeDefinitionForm = ({ name, }) => {
    const formProps = useFormContext();
    const [personalizationMenuState, loadPersonalizationMenus] = useService(MessageTemplateService.getPersonalizationMenusForPipelineCreateEmailNode);
    useEffect(() => {
        loadPersonalizationMenus();
    }, [loadPersonalizationMenus]);
    const hasLoggingPermission = useHasPermission("CAN_LOG_MESSAGES");
    return (_jsxs(_Fragment, { children: [_jsx(SendMessageActionEmailRecipientForm, Object.assign({}, formProps, { name: name })), _jsx(EmailForm, Object.assign({}, formProps, { personalizationMenus: personalizationMenuState, name: name, addDollarSignToVariables: true, withTemplate: false })), _jsx(AttachmentsField, { name: name + ".attachments" }), hasLoggingPermission && (_jsx("div", { className: "form-group", children: _jsx(CheckboxField, { label: "Log Message", name: name + ".logMessage", helpText: "If a student is the recipient of this message, show this message in their Messages and Activity tabs.\n              Logged messages will be stored on the student profile regardless of the delivery status." }) })), _jsx(SendMessageAsNoteForm, Object.assign({ name: name }, formProps))] }));
};
export default CreateEmailWorkflowNodeDefinitionForm;
